/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="600" height="160" {...props}>
    <circle cx="80" cy="80" r="74" stroke="#05F" strokeWidth="12"></circle>
    <circle cx="300" cy="80" r="74" stroke="#05F" strokeWidth="12"></circle>
    <circle cx="520" cy="80" r="74" stroke="#05F" strokeWidth="12"></circle>
    <circle cx="40" cy="98" r="8" fill="#05F"></circle>
    <circle cx="251" cy="66" r="8" fill="#05F"></circle>
    <circle cx="488" cy="46" r="8" fill="#05F"></circle>
    <circle cx="44" cy="72" r="8" fill="#05F"></circle>
    <circle cx="300" cy="57" r="8" fill="#05F"></circle>
    <circle cx="492" cy="78" r="8" fill="#05F"></circle>
    <circle cx="72" cy="56" r="8" fill="#05F"></circle>
    <circle cx="316" cy="91" r="8" fill="#05F"></circle>
    <circle cx="556" cy="62" r="8" fill="#05F"></circle>
    <circle cx="64" cy="119" r="8" fill="#05F"></circle>
    <circle cx="267" cy="107" r="8" fill="#05F"></circle>
    <circle cx="496" cy="118" r="8" fill="#05F"></circle>
    <circle cx="92" cy="119" r="8" fill="#05F"></circle>
    <circle cx="336" cy="111" r="8" fill="#05F"></circle>
    <circle cx="564" cy="98" r="8" fill="#05F"></circle>
    <circle cx="129" cy="82" r="8" fill="#05F"></circle>
    <circle cx="332" cy="66" r="8" fill="#05F"></circle>
    <circle cx="531" cy="37" r="8" fill="#05F"></circle>
    <circle cx="72" cy="88" r="8" fill="#05F"></circle>
    <circle cx="308" cy="123" r="8" fill="#05F"></circle>
    <circle cx="532" cy="131" r="8" fill="#05F"></circle>
    <circle cx="108" cy="48" r="8" fill="#05F"></circle>
    <circle cx="316" cy="37" r="8" fill="#05F"></circle>
    <circle cx="468" cy="95" r="8" fill="#05F"></circle>
    <circle cx="60" cy="32" r="8" fill="#05F"></circle>
    <circle cx="280" cy="48" r="8" fill="#05F"></circle>
    <circle cx="524" cy="95" r="8" fill="#05F"></circle>
    <circle cx="100" cy="80" r="8" fill="#05F"></circle>
    <circle cx="288" cy="90" r="8" fill="#05F"></circle>
    <circle cx="520" cy="70" r="8" fill="#05F"></circle>
  </Svg>
)

export default Icon
